import React, { PureComponent } from 'react';

import rawData from '~/assets/data/winloss.csv';
import withSlide from '~/kits/general/scripts/components/withSlide';

import WinLossChart from '../../components/WinLossChart';

import './WinLoss.styl';

const data = rawData.map(d => ({ ...d, value: +d.value }));

class WinnLossSlide extends PureComponent {
  render() {
    const { title, text } = this.props;

    return (
      <div className="wl-chart">
        <div className="slide-title">{title}</div>
        <div className="slide-text">{text}</div>

        <WinLossChart data={data} />
      </div>
    );
  }
}

export default withSlide(WinnLossSlide);
